module.exports = __webpack_public_path__ + "img/step6.a5dff014.png";